import Vue from 'vue'
import mainVue from './main.vue'

const defaults = {}

const MainConstructor = Vue.extend(mainVue)

let instance, currentBox

const defaultCallback = action => {
  if (currentBox) {
    let callback = currentBox.callback
    if (typeof callback === 'function') {
      callback(action)
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(action)
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action)
      }
    }
  }
}

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })

  instance.callback = defaultCallback
}

const showBox = () => {
  if (!instance) {
    initInstance()
  }

  instance.action = ''

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      let options = currentBox.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }

      let oldCb = instance.callback
      instance.callback = (action, instance) => {
        oldCb(action, instance)
      }

      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

const ImageViewBox = function (options, callback) {
  if (Vue.prototype.$isServer) return
  if (options.constructor === Array) {
    options = {
      files: options,
    }
    if (typeof arguments[1] === 'number') {
      options.index = arguments[1]
    }
  } else if (options.callback && !callback) {
    callback = options.callback
  }

  currentBox = {
    options: _.merge({}, defaults, ImageViewBox.defaults, options),
    callback: callback,
  }

  showBox()
}

ImageViewBox.setDefaults = defaults => {
  ImageViewBox.defaults = defaults
}

ImageViewBox.open = (files, index, options) => {
  return ImageViewBox(_.merge({
    files,
    index,
  }, options))
}

ImageViewBox.close = () => {
  instance.doClose()
  instance.visible = false
  currentBox = null
}

ImageViewBox.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default ImageViewBox

export { ImageViewBox }



// WEBPACK FOOTER //
// ./src/views/question-editor/components/image-view-box/src/main.js